import { change } from 'redux-form'

export const changeFieldValue = (form, field, value) => {
  return async dispatch => {
    dispatch(change(form, field, value))
  }
}
